<!-- Chip Display Mode -->
<ng-container *ngIf="useChipDisplay">
  <span
    class="tw-px-4 tw-py-1 tw-rounded-full tw-text-sm tw-hidden @md:tw-flex tw-items-center tw-gap-2 tw-border tw-border-solid tw-flex-shrink-0 tw-cursor-pointer"
    [ngClass]="{
      'tw-bg-[#102825] tw-text-[#7FFFD4] tw-border-[#1e3a34]': isFilterActive,
      'tw-bg-gray-800 tw-text-gray-300 tw-border-gray-700': !isFilterActive
    }"
    [matMenuTriggerFor]="chipMenu"
    (click)="onMenuOpened()">
    <ng-container *ngIf="isFilterActive">
      <button
        mat-icon-button
        (click)="clearSelection(); $event.stopPropagation()"
        class="tw-w-5 tw-h-5 tw-p-0 tw-flex tw-items-center tw-justify-center">
        <mat-icon inline class="tw-text-sm">close</mat-icon>
      </button>
      Role:
      <span class="tw-truncate">{{ chipText }}</span>
    </ng-container>
    <ng-container *ngIf="!isFilterActive">
      <mat-icon inline class="tw-text-[1.2em]">add</mat-icon>
      Role
    </ng-container>
  </span>

  <mat-menu #chipMenu="matMenu" class="role-chip-menu" (opened)="onMenuOpened()">
    <div
      class="tw-px-3 tw-py-1 tw-max-h-96 tw-min-w-[36rem]"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()">
      <div
        class="tw-flex tw-justify-between tw-items-center tw-px-1 xl:tw-px-2 tw-pb-3 tw-border-0 tw-border-solid tw-border-b tw-border-gray-600">
        <div class="tw-flex tw-items-center">
          <div class="tw-text-base tw-font-medium tw-text-gray-200">
            <span>Pick a role</span>
          </div>
        </div>
        <div class="tw-flex tw-items-center tw-gap-2">
          <button mat-button color="primary" (click)="onViewAll()">View All</button>
          <button *ngIf="allowNewRole" mat-button color="primary" (click)="onNewRoleClick()">
            <span class="tw-flex tw-items-center tw-gap-1">
              <mat-icon inline>add</mat-icon>
              New Role
            </span>
          </button>
        </div>
      </div>

      <div class="tw-mt-4">
        <!-- Show both columns when there are recent roles -->
        <div *ngIf="recentlyUsedRoles.length > 0" class="tw-grid tw-grid-cols-2 tw-gap-x-6">
          <!-- Recent Roles Column -->
          <div class="tw-col-span-1">
            <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Recent</h3>
            <div class="tw-space-y-3">
              <app-role-definition-item-renderer
                class="tw-block tw-mb-3"
                *ngFor="let role of recentlyUsedRoles; trackBy: trackByRoleId"
                [item]="role"
                [showCreator]="false"
                (itemSelected)="onSelectionChange($event.id)">
              </app-role-definition-item-renderer>
            </div>
          </div>

          <!-- Popular Roles Column -->
          <div class="tw-col-span-1">
            <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
            <div class="tw-space-y-3">
              <ng-container *ngIf="rolesLoaded; else loadingPopularRoles">
                <ng-container *ngIf="popularRoles.length > 0; else noPopularRoles">
                  <app-role-definition-item-renderer
                    class="tw-block tw-mb-3"
                    *ngFor="let role of popularRoles; trackBy: trackByRoleId"
                    [item]="role"
                    [showCreator]="false"
                    (itemSelected)="onSelectionChange($event.id)">
                  </app-role-definition-item-renderer>
                </ng-container>
                <ng-template #noPopularRoles>
                  <div class="tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
                    No popular roles available
                  </div>
                </ng-template>
              </ng-container>
              <ng-template #loadingPopularRoles>
                <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                  <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                </div>
              </ng-template>
            </div>
          </div>
        </div>

        <!-- Show only popular roles in 2 columns when no recent roles -->
        <div *ngIf="recentlyUsedRoles.length === 0">
          <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
          <div class="tw-grid tw-grid-cols-2 tw-gap-x-6">
            <div class="tw-col-span-1">
              <div class="tw-space-y-3">
                <ng-container *ngIf="rolesLoaded; else loadingFirstColumn">
                  <app-role-definition-item-renderer
                    class="tw-block tw-mb-3"
                    *ngFor="let role of popularRolesFirstColumn; trackBy: trackByRoleId"
                    [item]="role"
                    [showCreator]="false"
                    (itemSelected)="onSelectionChange($event.id)">
                  </app-role-definition-item-renderer>
                </ng-container>
                <ng-template #loadingFirstColumn>
                  <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                    <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                  </div>
                </ng-template>
              </div>
            </div>
            <div class="tw-col-span-1">
              <div class="tw-space-y-3">
                <ng-container *ngIf="rolesLoaded; else loadingSecondColumn">
                  <app-role-definition-item-renderer
                    class="tw-block tw-mb-3"
                    *ngFor="let role of popularRolesSecondColumn; trackBy: trackByRoleId"
                    [item]="role"
                    [showCreator]="false"
                    (itemSelected)="onSelectionChange($event.id)">
                  </app-role-definition-item-renderer>
                </ng-container>
                <ng-template #loadingSecondColumn>
                  <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                    <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div
            *ngIf="rolesLoaded && popularRolesExtended.length === 0"
            class="tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
            No popular roles available
          </div>
        </div>
      </div>
    </div>
  </mat-menu>
</ng-container>

<!-- Form Field Mode -->
<ng-container *ngIf="!useChipDisplay && !dropdownOnly">
  <mat-form-field
    appearance="outline"
    floatLabel="always"
    class="role-dropdown tw-w-full tw-min-w-[200px] tw-max-w-[400px]">
    <mat-label class="tw-text-gray-800 dark:tw-text-gray-100">Role</mat-label>
    <mat-select
      matInput
      [value]="selectedRoleId"
      (valueChange)="onSelectionChange($event)"
      (openedChange)="$event && onMenuOpened()"
      [placeholder]="!allowNewRole ? 'All' : ''">
      <mat-option *ngIf="allowNewRole" [value]="'new'">New Role</mat-option>
      <mat-option [value]="null">All</mat-option>
      <mat-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-option>
    </mat-select>
  </mat-form-field>
</ng-container>

<!-- Dropdown Only Mode (for use inside menus) -->
<ng-container *ngIf="dropdownOnly">
  <div
    class="tw-px-3 tw-py-1 tw-max-h-96 tw-min-w-[36rem]"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()">
    <div
      class="tw-flex tw-justify-between tw-items-center tw-px-1 xl:tw-px-2 tw-pb-3 tw-border-0 tw-border-solid tw-border-b tw-border-gray-600">
      <div class="tw-flex tw-items-center">
        <div class="tw-text-base tw-font-medium tw-text-gray-200">
          <span>Pick a role</span>
        </div>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <button mat-button color="primary" (click)="onViewAll()">View All</button>
        <button *ngIf="allowNewRole" mat-button color="primary" (click)="onNewRoleClick()">
          <span class="tw-flex tw-items-center tw-gap-1">
            <mat-icon inline>add</mat-icon>
            New Role
          </span>
        </button>
      </div>
    </div>

    <div class="tw-mt-4">
      <!-- Show both columns when there are recent roles -->
      <div *ngIf="recentlyUsedRoles.length > 0" class="tw-grid tw-grid-cols-2 tw-gap-x-6">
        <!-- Recent Roles Column -->
        <div class="tw-col-span-1">
          <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Recent</h3>
          <div class="tw-space-y-3">
            <app-role-definition-item-renderer
              class="tw-block tw-mb-3"
              *ngFor="let role of recentlyUsedRoles; trackBy: trackByRoleId"
              [item]="role"
              [showCreator]="role.scope !== 'public'"
              (itemSelected)="onSelectionChange($event.id)">
            </app-role-definition-item-renderer>
          </div>
        </div>

        <!-- Popular Roles Column -->
        <div class="tw-col-span-1">
          <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
          <div class="tw-space-y-3">
            <ng-container *ngIf="rolesLoaded; else loadingPopularRolesDropdown">
              <ng-container *ngIf="popularRoles.length > 0; else noPopularRolesDropdown">
                <app-role-definition-item-renderer
                  class="tw-block tw-mb-3"
                  *ngFor="let role of popularRoles; trackBy: trackByRoleId"
                  [item]="role"
                  [showCreator]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-role-definition-item-renderer>
              </ng-container>
              <ng-template #noPopularRolesDropdown>
                <div class="tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
                  No popular roles available
                </div>
              </ng-template>
            </ng-container>
            <ng-template #loadingPopularRolesDropdown>
              <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <!-- Show only popular roles in 2 columns when no recent roles -->
      <div *ngIf="recentlyUsedRoles.length === 0">
        <h3 class="tw-text-base tw-font-semibold tw-text-gray-200 tw-mb-3 tw-px-1">Popular</h3>
        <div class="tw-grid tw-grid-cols-2 tw-gap-x-6">
          <div class="tw-col-span-1">
            <div class="tw-space-y-3">
              <ng-container *ngIf="rolesLoaded; else loadingFirstColumnDropdown">
                <app-role-definition-item-renderer
                  class="tw-block tw-mb-3"
                  *ngFor="let role of popularRolesFirstColumn; trackBy: trackByRoleId"
                  [item]="role"
                  [showCreator]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-role-definition-item-renderer>
              </ng-container>
              <ng-template #loadingFirstColumnDropdown>
                <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                  <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                </div>
              </ng-template>
            </div>
          </div>
          <div class="tw-col-span-1">
            <div class="tw-space-y-3">
              <ng-container *ngIf="rolesLoaded; else loadingSecondColumnDropdown">
                <app-role-definition-item-renderer
                  class="tw-block tw-mb-3"
                  *ngFor="let role of popularRolesSecondColumn; trackBy: trackByRoleId"
                  [item]="role"
                  [showCreator]="false"
                  (itemSelected)="onSelectionChange($event.id)">
                </app-role-definition-item-renderer>
              </ng-container>
              <ng-template #loadingSecondColumnDropdown>
                <div class="tw-flex tw-items-center tw-justify-center tw-py-4">
                  <mat-spinner diameter="24" strokeWidth="3"></mat-spinner>
                </div>
              </ng-template>
            </div>
          </div>
        </div>
        <div
          *ngIf="rolesLoaded && popularRolesExtended.length === 0"
          class="tw-text-gray-500 tw-text-sm tw-px-1 tw-py-2">
          No popular roles available
        </div>
      </div>
    </div>
  </div>
</ng-container>
